import Config from "./config/config";

export default {
  modules: {
    authentication: {
      strict: true,
      namespaced: true,
      state: {
			authToken: Config.getCookie("auth") != "" ? Config.getCookie("auth") : null,
      checked: false,
      loggedIn: false,
      user_hash: "",
      user_name: "",
			user_role: "",
      },
      mutations: {
        login (state, data) {
          state.loggedIn = true
        }
      }
    },
    l: {
      strict: true,
      namespaced: true,
      state: {
        lang: parseInt(Config.getCookie("lang")) === 0 ? 0 : 1
      },
      mutations: {
        ts (state, data) {
          state.loggedIn = true
        }
      }
    },
    pending: {
      strict: true,
      namespaced: true,
      state: {
        is: false
      }
    }
  },
  
}



// WEBPACK FOOTER //
// ./src/store.js